var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKrtiLogoNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 29,
    viewBox: "0 0 96 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40_152)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_40_152",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 96,
    height: 29
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 0H0V29H96V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_40_152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.3167 28.9599H61.4141C61.1437 28.9599 60.9236 28.7389 60.9236 28.4672V15.0285C60.9236 10.1308 64.8743 6.1626 69.7504 6.1626H73.2769C73.5473 6.1626 73.7674 6.38365 73.7674 6.6553V11.5796C73.7674 11.8513 73.5473 12.0723 73.2769 12.0723H69.7504C68.125 12.0723 66.8073 13.396 66.8073 15.0285V28.4672C66.8073 28.7389 66.5872 28.9599 66.3167 28.9599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1263 0H39.2237C38.9528 0 38.7332 0.220589 38.7332 0.492699V28.5073C38.7332 28.7794 38.9528 29 39.2237 29H44.1263C44.3972 29 44.6168 28.7794 44.6168 28.5073V0.492699C44.6168 0.220589 44.3972 0 44.1263 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2847 28.9574H84.9328C80.0567 28.9574 76.106 24.9892 76.106 20.0915V0.492699C76.106 0.221049 76.326 0 76.5965 0H81.4991C81.7695 0 81.9896 0.221049 81.9896 0.492699V20.0915C81.9896 21.724 83.3074 23.0477 84.9328 23.0477H87.2847C87.5551 23.0477 87.7752 23.2687 87.7752 23.5404V28.4647C87.7752 28.7363 87.5551 28.9574 87.2847 28.9574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.895 12.0723H87.2847C87.5552 12.0723 87.7753 11.8513 87.7753 11.5796V6.6553C87.7753 6.38365 87.5552 6.1626 87.2847 6.1626H79.895V12.0723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9315 0H54.507C54.1808 0 53.8706 0.138488 53.6532 0.383506L42.3127 13.1324L56.0501 28.5739C56.2676 28.8189 56.5778 28.9574 56.9039 28.9574H63.4531C63.8349 28.9574 64.0364 28.5046 63.7819 28.2197L50.299 13.0632L61.2603 0.737717C61.5149 0.45275 61.3134 0 60.9315 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5096 6.1626H90.607C90.3361 6.1626 90.1165 6.38319 90.1165 6.6553V28.5072C90.1165 28.7793 90.3361 28.9999 90.607 28.9999H95.5096C95.7805 28.9999 96.0001 28.7793 96.0001 28.5072V6.6553C96.0001 6.38319 95.7805 6.1626 95.5096 6.1626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5096 0H90.607C90.3361 0 90.1165 0.220589 90.1165 0.492699V3.57673C90.1165 3.84884 90.3361 4.06943 90.607 4.06943H95.5096C95.7805 4.06943 96.0001 3.84884 96.0001 3.57673V0.492699C96.0001 0.220589 95.7805 0 95.5096 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02607 0H2.1318C0.954538 0 0 0.958766 0 2.14124V26.8614C0 28.0439 0.954538 29.0027 2.1318 29.0027H8.02607C8.39198 29.0027 8.63592 28.6325 8.49804 28.2916C6.79313 24.0304 5.85715 19.3751 5.85715 14.5013C5.85715 9.62761 6.79578 4.97493 8.49804 0.711085C8.63326 0.37019 8.38933 0 8.02607 0Z",
    fill: "#58B8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2585 14.4774C10.2585 19.6094 12.0616 24.318 15.0604 28.0013C15.5695 28.6271 16.3437 28.976 17.1498 28.976H25.0804C25.5762 28.976 25.7698 28.3342 25.3615 28.0519C20.2759 24.571 16.2721 19.6946 16.2721 14.4747V14.496C16.2721 9.27606 20.2785 4.39967 25.3615 0.918817C25.7724 0.64184 25.5789 0 25.0804 0H17.1498C16.3437 0 15.5721 0.348884 15.0604 0.974745C12.0589 4.66067 10.2585 9.36661 10.2585 14.4987V14.4774Z",
    fill: "#58B8FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKrtiLogoNew);
export default __webpack_public_path__ + "static/media/krti_logo_new.4f6e8d331a43b3a21ae8df5c2e8f2673.svg";
export { ForwardRef as ReactComponent };